























































































import { changeLoading } from '@/util/plugins';
const dateFormat = require('bmh/date-format');
import { Component, Vue } from 'vue-property-decorator';
import { Moment } from 'moment';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_API, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  getlist: `${FCAPI}/shang/ruan/order/deposit`,
};
const status = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 5,
    label: '下订',
  },
  {
    value: 6,
    label: '签约',
  },
  {
    value: 8,
    label: '退单',
  },
];
interface Form {
  city: string;
  order_brand: string;
  user_name: string;
  order_time: Moment[];
}
function initForm() {
  return {
    city: '',
    order_brand: '',
    user_name: '',
    order_time: [],
  };
}
interface Table<T> {
  limit: number;
  total: number;
  detail: T[];
  current: number;
  last: number;
}
function getData(remote?: Table<any>) {
  remote = (remote || {}) as Table<any>;
  return {
    total: remote.total || 0,
    limit: remote.limit || 1,
    current: remote.current || 1,
    data: remote.detail || [],
    last: remote.last || 1,
    detail: remote.detail || [],
  };
}
@Component
export default class OrderUser extends Vue {
  is_loading: boolean = false;
  show_modal: boolean = false;
  form: Form = initForm();
  product_form: any;
  edit_record: any = {};
  table_data: Table<any> = getData();
  get status() {
    return status;
  }
  @changeLoading(['is_loading'])
  async search(page: number = 1) {
    const start_time = this.form.order_time[0]
      ? Math.floor((this.form.order_time[0] as any).hours(0).minutes(0).seconds(0) / 1000)
      : '';
    const end_time = this.form.order_time[1]
      ? Math.floor((this.form.order_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1
      : '';
    const send_data = {
      name_or_mobile: this.form.user_name ? this.form.user_name : '',
      city: this.form.city ? this.form.city : '',
      limit: 50,
      brand: this.form.order_brand ? this.form.order_brand : '',
      current: page,
      create_start_time: start_time,
      create_end_time: end_time,
    };
    const url = getUrl(API.getlist, send_data);
    const res = await this.$axios.get(url);
    if (res.data.status === 200) {
      res.data.data.detail.forEach((item: any) => {
        item.brand_json = JSON.parse(item.brand_json);
      });
      this.table_data = getData(res.data.data);
    }
  }
  submit() {
    this.product_form.validateFields((err: any, value: any) => {
      if (!err) {
        console.log(value);
      }
    });
  }
  formatDeposit(id: any) {
    const format_str = '00000000';
    id = '' + id;
    return `D${format_str.substr(0, 8 - id.length)}${id}`;
  }
  formatMobile(phone: any) {
    phone = '' + phone;
    const tel = phone.substr(0, 3) + '****' + phone.substr(7);
    return tel;
  }
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  changePage(page: any) {
    this.search(page.current);
  }
  clearForm() {
    this.form = initForm();
  }
  add() {
    this.show_modal = true;
    this.product_form.resetFields();
  }
  edit(record: any) {
    this.show_modal = true;
    setTimeout(() => {
      this.product_form.setFieldsValue({
        mission_name: record.title,
      });
    });
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  beforeCreate() {
    this.product_form = this.$form.createForm(this);
  }
  created() {
    this.search(1);
  }
}
